import React, { useContext } from "react"
import { modalContext } from 'global/context/sub-contexts/modalContext'

import './Bridge.scss'

const Bridge = ({pointsEarned = 0}) => {
  const modal_context = useContext(modalContext)
  const {showSignUpModalTab} = modal_context || {}
  const signUpOptions = {redirect: "/"}

  return (
    <div className={`bridge-section`}>
      {pointsEarned > 0 ? (
      <>
        <h4>You earned {pointsEarned} points!</h4>
        <p>You can use those points to enter sweepstakes and win gift cards!</p>
        <a className="btn" onClick={() => showSignUpModalTab(signUpOptions)}>Redeem points and continue</a>
      </>
      ) : (
      <>
        <h4>Sign up to earn points and win gift cards!</h4>
        <a className="btn" onClick={() => showSignUpModalTab(signUpOptions)}>Continue to signup</a>
      </>
      )}
    </div>
  )
}
export default Bridge
